import React, { Component } from 'react';
import { AgGridReact } from 'ag-grid-react';
import moment from 'moment';
import FamilyBtnCellRenderer from './familyBtnCellRenderer';
import FamilySearchMenu from './familySearchMenu';
import { searchFamilies } from '../../../../services/clinicPortalServices/familyService';
import { getUserRole, defaultExcelExportParams, processCellForClipboard } from '../../../../services/common/util';
import { ThemeContext } from '../../../../theme/ThemeProvider';
import { colorSchemeDark, colorSchemeLight, themeQuartz } from 'ag-grid-community';

const themeLight = themeQuartz.withPart(colorSchemeLight);
const themeDark = themeQuartz.withPart(colorSchemeDark);

class FamilyGrid extends Component {
    constructor(props) {
        super(props);
        this.state = {
            paginationPageSize: 20,
            quickFilterText: '',
            columnDefs: [
                {
                    headerName: 'Actions', colId: 'actions',
                    minWidth: 150,
                    maxWidth: 150,
                    cellStyle: { textAlign: 'center' },
                    cellRenderer: 'familyBtnCellRenderer',
                    resizable: true,
                    hide: /audit/.test(getUserRole().toLowerCase())
                },
                {
                    headerName: 'Family Name',
                    field: 'family_name',
                    minWidth: 200,
                    resizable: true
                },
                {
                    headerName: 'Family ID',
                    field: 'family_id',
                    minWidth: 150,
                    resizable: true
                },
                {
                    headerName: 'Number of Members',
                    field: 'member_count',
                    minWidth: 150,
                    resizable: true
                },
                {
                    headerName: 'Created Date',
                    field: 'createdAt',
                    minWidth: 180,
                    resizable: true,
                    valueGetter: (params) => {
                        return params.data.createdAt
                            ? moment(params.data.createdAt).format('MM/DD/YYYY hh:mm A')
                            : '';
                    }
                },
                {
                    headerName: 'Updated Date',
                    field: 'updatedAt',
                    minWidth: 180,
                    resizable: true,
                    valueGetter: (params) => {
                        return params.data.updatedAt
                            ? moment(params.data.updatedAt).format('MM/DD/YYYY hh:mm A')
                            : '';
                    }
                }
            ],
            components: {
                familyBtnCellRenderer: FamilyBtnCellRenderer
            },
            defaultColDef: {
                flex: 1,
                filter: true,
                sortable: true
            },
            rowData: [],
            context: { componentParent: this }
        };
    }

    componentDidMount() {
        this.loadGridData();
    }

    autoFitActions = (params) => {

        const api = (params && params.api) || this.gridApi;

        if (api && api.autoSizeColumns) setTimeout(() => { try { api.autoSizeColumns(['actions'], false); } catch (e) { /* ignore */ } }, 60);

    };


    onGridReady = (params) => {
        this.gridApi = params.api;
    };

    loadGridData = () => {
        if (this.gridApi) {
            this.gridApi.showLoadingOverlay();
        }
        searchFamilies({})
            .then((response) => {
                const data = response?.data || [];
                this.setState({ rowData: data });

                if (this.gridApi) {
                    if (!data.length) {
                        this.gridApi.showNoRowsOverlay();
                    } else {
                        this.gridApi.hideOverlay();
                    }
                }
            })
            .catch((error) => {
                console.error('Error loading families:', error);
                this.setState({ rowData: [] });
                if (this.gridApi) {
                    this.gridApi.showNoRowsOverlay();
                }
            });
    };

    onFilterTextChange = (e) => {
        this.setState({ quickFilterText: e.target.value });
    };

    onBtnExport = () => {
        this.gridApi.exportDataAsExcel({
            fileName: 'Family_Grid_' + moment().format('YYYY_MM_DD_HH_mm_ss') + '.xlsx',
            sheetName: 'Families'
        });
    };

    onPageSizeChanged = (e) => {
        this.setState({ paginationPageSize: Number(e.target.value) });
    };

    clearFilter = () => {
        this.gridApi.setFilterModel(null);
        this.setState({ quickFilterText: '' });
        document.getElementById('reset-form').value = '';
        this.loadGridData();
    };

    updateGridRow = (nodeId, newData) => {
        let updatedRowNode = this.gridApi.getRowNode(nodeId);
        let data = Object.assign({}, updatedRowNode.data, newData);
        updatedRowNode.setData(data);
    };

    render() {
        return (
            <div className="clinic-contain">
                <FamilySearchMenu
                    onFilterTextChange={this.onFilterTextChange}
                    clearFilter={this.clearFilter}
                    onBtnExport={this.onBtnExport}
                    onPageSizeChanged={this.onPageSizeChanged}
                    pageSize={this.state.paginationPageSize}
                    context={this.state.context}
                />

                <div style={{ width: '100%', height: 'calc(100vh - 250px)', padding: '15px' }}>
                    <ThemeContext.Consumer>
                        {({ themeName }) => (
                            <div style={{ height: '100%', width: '100%' }}>
                                <AgGridReact
                                    columnDefs={this.state.columnDefs}
                                    defaultColDef={this.state.defaultColDef}
                                    onGridReady={this.onGridReady}
                                    onFirstDataRendered={this.autoFitActions}
                                    onRowDataUpdated={this.autoFitActions}
                                    rowData={this.state.rowData}
                                    components={this.state.components}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    paginationPageSizeSelector={false}
                                    context={this.state.context}
                                    defaultExcelExportParams={defaultExcelExportParams}
                                    processCellForClipboard={processCellForClipboard}
                                    theme={themeName === 'Light' ? themeLight : themeDark}
                                    quickFilterText={this.state.quickFilterText}
                                />
                            </div>
                        )}
                    </ThemeContext.Consumer>
                </div>
            </div>
        );
    }
}

export default FamilyGrid;
